const SITE_ID = 11;const SITE_UID='a3e2b58b-9165-4693-a869-ca89107d1239';const SUBDOMAIN='jeju';export { SITE_ID, SITE_UID, SUBDOMAIN }